import React from 'react'
import { Route, Navigate, Outlet, useParams } from 'react-router-dom';

import RouteGuard from 'components/AuthenticatedLayout/RouteGuard/RouteGuard'

import AudinDocuments from './Audin/AudinDocuments';
import CenterDocuments from './Center/CenterDocuments';
import EditionLoader from './Center/Edition/Components/EditionLoader';
import RemoveDocument from './Center/Deletion/Modals/RemoveModal';

const DocumentComponent = () => {
  const { type } = useParams();
  
  if (type === 'center') {
    return (
      <RouteGuard 
        requiredRoles={[
          'documents_support_documentation',
          'documents_financial_report',
          'documents_indicator_report',
          'documents_other_documents'
        ]}
      >
        <CenterDocuments />
      </RouteGuard>
    );
  }
  
  return (
    <RouteGuard 
      requiredRoles={[
        'documents_audin_audit',
        'documents_audin_integration',
        'documents_audin_technical_visit',
        'documents_audin_revised_technical_visit'
      ]}
    >
      <AudinDocuments />
    </RouteGuard>
  );
};

export const DocumentRoutes = () => [
  <Route path="/documents" key="documents" element={<Outlet />}>
    <Route index element={<Navigate to="/documents/audin" replace />} />
    <Route path=":type" element={<DocumentComponent />}>
      <Route path="create" element={<EditionLoader />} />
      <Route path=":id" element={<Outlet />}>
        <Route path="edit" element={<EditionLoader />} />
        <Route path="delete" element={<RemoveDocument />} />
      </Route>
    </Route>
  </Route>
];

export default DocumentRoutes;
